import { createReducer, on } from '@ngrx/store';
import { Division } from '@app/store/shared/models';
import { ROWS_PER_PAGE } from '@shared/components';
import { divisionsActions } from '../actions/divisions.actions';
import { DivisionLookup, GetDivisionsValue } from '../models';

export interface DivisionsState {
    loaded: boolean | null;
    loading: boolean;
    divisions: Division[];
    value: GetDivisionsValue;
    total: number;
    lookupLoaded: boolean | null;
    lookup: DivisionLookup[];
}

export const initialState: DivisionsState = {
    loaded: null,
    loading: false,
    divisions: [],
    value: { page: 1, limit: ROWS_PER_PAGE[0] },
    total: 0,
    lookupLoaded: null,
    lookup: [],
};

export const divisionsReducer = createReducer(
    initialState,
    // List
    on(divisionsActions.getDivisions, (state, { value }): DivisionsState => ({ ...state, value, loading: true })),
    on(divisionsActions.getDivisionsSuccess, (state, { payload }): DivisionsState => ({
        ...state,
        loading: false,
        loaded: true,
        divisions: payload.items,
        total: payload.total,
    })),
    on(divisionsActions.getDivisionsError, (state): DivisionsState => ({ ...state, loading: false, loaded: false })),
    // Lookup
    // A loaded lookup stays loaded while it refetches, so a revisited form shows its options at once; a failed one goes back to pending.
    on(divisionsActions.getDivisionsLookup, (state): DivisionsState => ({ ...state, lookupLoaded: state.lookupLoaded || null })),
    on(divisionsActions.getDivisionsLookupSuccess, (state, { payload }): DivisionsState => ({ ...state, lookupLoaded: true, lookup: payload })),
    on(divisionsActions.getDivisionsLookupError, (state): DivisionsState => ({ ...state, lookupLoaded: false })),
    // Clear
    on(divisionsActions.clear, (): DivisionsState => ({ ...initialState })),
);
